<template>
    <div class="modal" v-if="activeTicket">
        <div class="modal__container">
            <div class="modal__inner modal__inner--secondary">
                <h3 class="modal__ttl modal__ttl--primary">
                    {{ activeTicket.type }}
                </h3>
                <h4 class="modal__ttl modal__ttl--primary">
                    Receive an email when tickets are available
                </h4>
                <form class="form form--primary" onsubmit="return false;">
                    <table>
                        <tbody>
                            <tr>
                                <td class="text-right text-darker">
                                    <span>First Name:</span>
                                </td>
                                <td class="py-0">
                                    <div class="form__field mb-0">
                                        <input
                                            type="text"
                                            name="first_name"
                                            v-model="formData.firstName"
                                            class="
                                                form__input
                                                form__input--quaternary
                                                option-select
                                            "
                                            required
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-right text-darker">
                                    <span>Last Name:</span>
                                </td>
                                <td class="py-0">
                                    <div class="form__field mb-0">
                                        <input
                                            type="text"
                                            name="last_name"
                                            v-model="formData.lastName"
                                            class="
                                                form__input
                                                form__input--quaternary
                                                option-select
                                            "
                                            required
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-right text-darker">
                                    <span>Email:</span>
                                </td>
                                <td class="py-0">
                                    <div class="form__field mb-0">
                                        <input
                                            type="email"
                                            name="email"
                                            v-model="formData.email"
                                            class="
                                                form__input
                                                form__input--quaternary
                                                option-select
                                            "
                                            required
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr class="form-error-message" v-show="formError">
                                <td colspan="2">
                                    <div class="form__error">
                                        <p>Please complete all fields</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-right" colspan="2">
                                    <button
                                        type="button"
                                        class="btn btn--quaternary"
                                        @click="submit"
                                    >
                                        {{ __("Submit") }}
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="flex justify-end">
                        <a
                            href="#"
                            @click.prevent="close"
                        >
                            <i class="fas fa-times"></i>
                            <span>{{ __("Cancel") }}</span>
                        </a>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "out-of-stock-modal",

    props: {
        activeTicket: {
            type: Object,
            default: false,
        },
        event: {
            type: Object,
            default: false,
        },
        schedule: {
            type: Object,
            default: false,
        },
        venue: {
            type: Object,
            default: false,
        },
    },
    data: function () {
        return {
            formData: {
                firstName: "",
                lastName: "",
                email: "",
            },
            formError: null,
        };
    },
    methods: {
        submit() {
            window._klaviyoHelper.recordIdentity({
                $email: this.formData.email,
                $first_name: this.formData.firstName,
                $last_name: this.formData.lastName,
            });

            setTimeout(() => {
                window._klaviyoHelper.recordEvent([
                    "track",
                    "notify when back in stock",
                    {
                        event_name: this.event.title,
                        schedule_date: this.schedule.date,
                        venue_name: this.venue.name,
                        ticket_type: this.activeTicket.type,
                        ticket_price: this.activeTicket.price,
                    },
                ]);
            }, 250);

            this.close();
            this.$toasted.show(this.__("Submitted. We will email you when tickets are available"), {
                theme: "bubble",
                type: "success",
                position: "top-center",
                duration: 3000,
            });
        },
        close() {
            this.$emit("close", true);
        },
    },
};
</script>
<style lang="scss" scoped>
h4 {
    &.modal__ttl--primary {
        font-size: 24px;
    }
}
table {
    margin: 0 auto;
    color: #fff;
    td {
        padding: 10px;
    }
    select {
        font-size: 18px;
    }
}
.modal__close {
    margin-top: 40px;
}
.form-error-message {
    text-align: center;
}
.form__error {
    p {
        font-size: 18px;
        font-weight: bold;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/OutOfStockModal.vue